import React from "react";
import { Table, Button, Typography, Tag } from "antd";
import { useIntl } from "react-intl";
import { useSelector } from "react-redux";
import Moment from "moment";
import { extendMoment } from "moment-range";
import { useParams, useLocation } from "react-router-dom";
import Date from "../../../components/tables/Date";
import { CloseOutlined } from "@ant-design/icons";
import ModalContentWrapper from "../../plan/components/ModalContentWrapper.style";

const moment = extendMoment(Moment);
const { Title, Text } = Typography;
const ReplacedByEventsContent = (props) => {
  const { onMouseOver, onMouseOut, events, hide } = props;
  let { branchId } = useParams();
  const intl = useIntl();
  let location = useLocation();
  const currentAppLocale = useSelector((state) => state.user.currentAppLocale);
  const columns = [
    {
      title: intl.formatMessage({
        id: "app.plans.singleEventsEmployeeName",
      }),
      dataIndex: "employee",
      render(text, record) {
        const name =
          record.employee.surename + " " + record.employee.first_name;
        return (
          <Button
            className="ant-button-link"
            style={{ color: "inherit", textDecoration: "underline" }}
            type="text"
            href={
              location.pathname.includes("employees")
                ? `../../../branches/${branchId}/employees/${record.employee.id}`
                : `../../branches/${branchId}/employees/${record.employee.id}`
            }
          >
            {name}
          </Button>
        );
      },
      width: "180px",
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.patient",
      }),
      dataIndex: "order",
      sorter: (a, b) => a.employee.surename.localeCompare(b.employee.surename),
      sortDirections: ["descend", "ascend"],
      ellipsis: true,
      width: "180px",
      render(text, record) {
        const name =
          record.order.patient.surename + " " + record.order.patient.first_name;
        return (
          <Button
            type="text"
            className="ant-button-link"
            href={
              location.pathname.includes("employees")
                ? `../../../branches/${branchId}/patients/${record.order.patient.id}`
                : `../../branches/${branchId}/patients/${record.order.patient.id}`
            }
          >
            {name}
          </Button>
        );
      },
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.date",
      }),
      dataIndex: "date",
      render(text, record) {
        return <Date text={text} format={"L"} />;
      },
      sorter: (a, b) => a["date"].localeCompare(b["date"]),
      sortDirections: ["descend", "ascend"],
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.dayInWeek",
      }),
      responsive: ["lg"],
      dataIndex: "date",
      render(text, record) {
        return <Text>{moment.weekdays(moment(text).weekday())}</Text>;
      },
      width: "80px",
    },

    {
      title: intl.formatMessage({
        id: "app.scheduling.table.hours",
      }),
      responsive: ["md"],
      render(text, record) {
        return record ? (
          <Text>{`${moment(record.date).format("HH:mm")} : ${moment(record.date)
            .add(record.duration_minutes, "minutes")
            .format("HH:mm")}`}</Text>
        ) : null;
      },
      width: "120px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.client",
      }),
      dataIndex: "order",
      responsive: ["lg"],
      render(text, record) {
        return (
          <Text ellipsis={true}>
            {text["client"] ? text["client"]["name"] : ""}
          </Text>
        );
      },
      sorter: (a, b) => a.order.client.name.localeCompare(b.order.client.name),
      sortDirections: ["descend", "ascend"],
      width: "150px",
    },
    {
      title: intl.formatMessage({
        id: "app.scheduling.table.status",
      }),
      responsive: ["md"],
      dataIndex: "approved",
      render(text, record) {
        return text ? (
          <Tag color="success">
            {intl.formatMessage({
              id: "app.scheduling.table.verified",
            })}
          </Tag>
        ) : record.ghost ? (
          <Tag color="error">
            {intl.formatMessage({
              id: "app.scheduling.table.deleted",
            })}
          </Tag>
        ) : null;
      },
      width: "80px",
    },
  ];

  return (
    <ModalContentWrapper direction={currentAppLocale.direction}>
      <div className="top" onMouseOver={onMouseOver} onMouseOut={onMouseOut}>
        <Button
          className="closeBtn"
          type="text"
          shape="circle"
          icon={<CloseOutlined />}
          onClick={hide}
        />
      </div>
      <div className="inner">
        <Title level={5}>
          {intl.formatMessage({
            id: "app.plans.replacementsEventsModalTitle",
          })}
        </Title>

        <div style={{ width: "940px" }}>
          <Table
            bordered
            dataSource={events}
            columns={columns}
            rowKey={(record) => record.id}
            pagination={false}
            scroll={{
              y: window.innerHeight - 400,
            }}
          />
        </div>
      </div>
    </ModalContentWrapper>
  );
};

export default ReplacedByEventsContent;
